import { Global, css } from '@emotion/core'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import React, { Suspense } from 'react'

import '@fortawesome/fontawesome-free/css/all.min.css'
import 'buddy-glud-component/build/style.css'
import 'react-spring-bottom-sheet/dist/style.css'
import MobileStyle from 'buddy-glud-component/lib/MobileStyle'
import { history } from './utils'
import configureStore from './store/configureStore'
import route from './routes'

import { keycloakProviderInitConfig, keycloakConfig } from './keycloak/KeycloakConfig'

import PrivateRoute from './keycloak/PrivateRoute'

import { ReactKeycloakProvider } from '@react-keycloak/web'

const store = configureStore(window.__INITIAL_STATE__)

const globalStyles = css`
  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-Black.eot');
    src: url('fonts/Kanit-Black.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-Black.woff2') format('woff2'),
        url('fonts/Kanit-Black.woff') format('woff'),
        url('fonts/Kanit-Black.ttf') format('truetype'),
        url('fonts/Kanit-Black.svg#Kanit-Black') format('svg');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-BoldItalic.eot');
    src: url('fonts/Kanit-BoldItalic.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-BoldItalic.woff2') format('woff2'),
        url('fonts/Kanit-BoldItalic.woff') format('woff'),
        url('fonts/Kanit-BoldItalic.ttf') format('truetype'),
        url('fonts/Kanit-BoldItalic.svg#Kanit-BoldItalic') format('svg');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-BlackItalic.eot');
    src: url('fonts/Kanit-BlackItalic.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-BlackItalic.woff2') format('woff2'),
        url('fonts/Kanit-BlackItalic.woff') format('woff'),
        url('fonts/Kanit-BlackItalic.ttf') format('truetype'),
        url('fonts/Kanit-BlackItalic.svg#Kanit-BlackItalic') format('svg');
    font-weight: 900;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-Bold.eot');
    src: url('fonts/Kanit-Bold.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-Bold.woff2') format('woff2'),
        url('fonts/Kanit-Bold.woff') format('woff'),
        url('fonts/Kanit-Bold.ttf') format('truetype'),
        url('fonts/Kanit-Bold.svg#Kanit-Bold') format('svg');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-ExtraLight.eot');
    src: url('fonts/Kanit-ExtraLight.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-ExtraLight.woff2') format('woff2'),
        url('fonts/Kanit-ExtraLight.woff') format('woff'),
        url('fonts/Kanit-ExtraLight.ttf') format('truetype'),
        url('fonts/Kanit-ExtraLight.svg#Kanit-ExtraLight') format('svg');
    font-weight: 200;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-ExtraBoldItalic.eot');
    src: url('fonts/Kanit-ExtraBoldItalic.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-ExtraBoldItalic.woff2') format('woff2'),
        url('fonts/Kanit-ExtraBoldItalic.woff') format('woff'),
        url('fonts/Kanit-ExtraBoldItalic.ttf') format('truetype'),
        url('fonts/Kanit-ExtraBoldItalic.svg#Kanit-ExtraBoldItalic') format('svg');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-ExtraBold.eot');
    src: url('fonts/Kanit-ExtraBold.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-ExtraBold.woff2') format('woff2'),
        url('fonts/Kanit-ExtraBold.woff') format('woff'),
        url('fonts/Kanit-ExtraBold.ttf') format('truetype'),
        url('fonts/Kanit-ExtraBold.svg#Kanit-ExtraBold') format('svg');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-ExtraLightItalic.eot');
    src: url('fonts/Kanit-ExtraLightItalic.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-ExtraLightItalic.woff2') format('woff2'),
        url('fonts/Kanit-ExtraLightItalic.woff') format('woff'),
        url('fonts/Kanit-ExtraLightItalic.ttf') format('truetype'),
        url('fonts/Kanit-ExtraLightItalic.svg#Kanit-ExtraLightItalic') format('svg');
    font-weight: 200;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-Light.eot');
    src: url('fonts/Kanit-Light.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-Light.woff2') format('woff2'),
        url('fonts/Kanit-Light.woff') format('woff'),
        url('fonts/Kanit-Light.ttf') format('truetype'),
        url('fonts/Kanit-Light.svg#Kanit-Light') format('svg');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-Italic.eot');
    src: url('fonts/Kanit-Italic.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-Italic.woff2') format('woff2'),
        url('fonts/Kanit-Italic.woff') format('woff'),
        url('fonts/Kanit-Italic.ttf') format('truetype'),
        url('fonts/Kanit-Italic.svg#Kanit-Italic') format('svg');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-MediumItalic.eot');
    src: url('fonts/Kanit-MediumItalic.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-MediumItalic.woff2') format('woff2'),
        url('fonts/Kanit-MediumItalic.woff') format('woff'),
        url('fonts/Kanit-MediumItalic.ttf') format('truetype'),
        url('fonts/Kanit-MediumItalic.svg#Kanit-MediumItalic') format('svg');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-LightItalic.eot');
    src: url('fonts/Kanit-LightItalic.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-LightItalic.woff2') format('woff2'),
        url('fonts/Kanit-LightItalic.woff') format('woff'),
        url('fonts/Kanit-LightItalic.ttf') format('truetype'),
        url('fonts/Kanit-LightItalic.svg#Kanit-LightItalic') format('svg');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-Medium.eot');
    src: url('fonts/Kanit-Medium.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-Medium.woff2') format('woff2'),
        url('fonts/Kanit-Medium.woff') format('woff'),
        url('fonts/Kanit-Medium.ttf') format('truetype'),
        url('fonts/Kanit-Medium.svg#Kanit-Medium') format('svg');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-Regular.eot');
    src: url('fonts/Kanit-Regular.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-Regular.woff2') format('woff2'),
        url('fonts/Kanit-Regular.woff') format('woff'),
        url('fonts/Kanit-Regular.ttf') format('truetype'),
        url('fonts/Kanit-Regular.svg#Kanit-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-SemiBold.eot');
    src: url('fonts/Kanit-SemiBold.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-SemiBold.woff2') format('woff2'),
        url('fonts/Kanit-SemiBold.woff') format('woff'),
        url('fonts/Kanit-SemiBold.ttf') format('truetype'),
        url('fonts/Kanit-SemiBold.svg#Kanit-SemiBold') format('svg');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-SemiBoldItalic.eot');
    src: url('fonts/Kanit-SemiBoldItalic.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-SemiBoldItalic.woff2') format('woff2'),
        url('fonts/Kanit-SemiBoldItalic.woff') format('woff'),
        url('fonts/Kanit-SemiBoldItalic.ttf') format('truetype'),
        url('fonts/Kanit-SemiBoldItalic.svg#Kanit-SemiBoldItalic') format('svg');
    font-weight: 600;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-ThinItalic.eot');
    src: url('fonts/Kanit-ThinItalic.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-ThinItalic.woff2') format('woff2'),
        url('fonts/Kanit-ThinItalic.woff') format('woff'),
        url('fonts/Kanit-ThinItalic.ttf') format('truetype'),
        url('fonts/Kanit-ThinItalic.svg#Kanit-ThinItalic') format('svg');
    font-weight: 100;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('fonts/Kanit-Thin.eot');
    src: url('fonts/Kanit-Thin.eot?#iefix') format('embedded-opentype'),
        url('fonts/Kanit-Thin.woff2') format('woff2'),
        url('fonts/Kanit-Thin.woff') format('woff'),
        url('fonts/Kanit-Thin.ttf') format('truetype'),
        url('fonts/Kanit-Thin.svg#Kanit-Thin') format('svg');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
  }

  html,
  body {
    background: #fcfcfc;
    overflow: hidden;
    font-family: 'Kanit';
    width: 100%;
    height: 100%;
  }
  .box-loading{ z-index: 2000; }
  .clearfix:before,
  .clearfix:after {
      content: " ";
      display: table;
  }

  .clearfix:after {
      clear: both;
  }
  .clearfix {
      *zoom: 1;
  }

  ::-webkit-scrollbar { width: 0px; }

  .modal.is-active {
    z-index: 99999;
    .modal-card {
      width: 435px;
      margin: 0px auto;
      .modal-card-body {
        padding: 20px 10px;
      }
    }
  }
  
  .modal-card-foot {
    .row { width: 100%; }
  }

  .slide-pane__overlay{
    z-index: 1009;
    background-color: rgba(0,0,0,0.6) !important;
    top: 0px !important;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: end;
    .slide-pane__header {
      flex: 0 0 40px !important;
      border-bottom: none !important;
      .slide-pane__title {
        color: #4a4a4a;
        font-size: 24px;
        font-weight: 500;
        padding: 15px 30px;
      }
      .slide-pane__subtitle { padding: 0px 30px 11px; }
    }
    .slide-pane__close {
      display: none !important;
    }
    .slide-pane__header {
      background: #FFFFFF !important;
    }
    .slide-pane__title-wrapper {
      margin-left: 10px;
      .slide-pane__title { color: #4a4a4a; }
    }
    .slide-pane__content {
      display: flex;
      flex-direction: column;
      padding: 0px 30px !important;
      width: 100%;
      height: calc(100% - 77px);
      background-color: #FFFFFF;
      overflow: auto;
    }

    .sliding-custom-promotion {
      .slide-pane__content {
        height: calc(100% - 140px);
      }
    }
  }
  .cart-blank {
    height: calc(100vh - 175px);
  }

  .app-max-width {
    max-width: 1024px;
    margin: 0px auto;
    width: 100%;
  }
  .tech-message {
    color: #ed1c24;
    margin-top: 10px;
    background-color: #F4F4F4;
    padding: 5px;
    border-radius: 3px;
  }
  /* .row {
    margin-top: -10px;
    margin-bottom: -10px;
  } */

  .box-datarange-wrapper { z-index: 2000; }

  @media only screen and (max-width: 375px),
    only screen and (max-width: 411px),
    only screen and (max-width: 414px) {
      .modal.is-active {
        .modal-card {
          width: 370px;
        }
      }
  }

  @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {
    html {
      transform: rotate(-90deg);
      transform-origin: left top;
      width: 100vh;
      overflow-x: hidden;
      position: absolute;
      top: 100%;
      left: 0;
    }
  }
`

function Root() {
  // if(cookieStorage.get('xxopoc')) {
  //   return (
  //     <Provider store={store}>
  //       <MobileStyle />
  //       <Suspense fallback={null}>
  //         <Global styles={globalStyles} />
  //         <PrivateRoute>
  //           <Router history={history}>{route}</Router>
  //         </PrivateRoute>
  //       </Suspense>
  //     </Provider>
  //   )
  // }
  // else {
    
  // }
  return (
    <ReactKeycloakProvider
      authClient={keycloakConfig}
      initOptions={keycloakProviderInitConfig}
      // onEvent={onKeycloakEvent}
      // onTokens={onKeycloakTokens}
    >
      <Provider store={store}>
        <MobileStyle />
        <Suspense fallback={null}>
          <Global styles={globalStyles} />
          <PrivateRoute>
            <Router history={history}>{route}</Router>
          </PrivateRoute>
        </Suspense>
      </Provider>
    </ReactKeycloakProvider>
  )
}

export default Root

